import { render, staticRenderFns } from "./ReportModalWrapper.vue?vue&type=template&id=268bdada&scoped=true"
import script from "./ReportModalWrapper.vue?vue&type=script&lang=js"
export * from "./ReportModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268bdada",
  null
  
)

export default component.exports